import React from 'react';
import Login from '../components/Auth/Login';

const LoginPage: React.FC<{ onLoginSuccess: () => void }> = ({ onLoginSuccess }) => {
  return (
    
      <Login onLoginSuccess={onLoginSuccess} />
  );
};

export default LoginPage;